/*
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
*/

// IP-NOTICE: CUSTOM
import { Injectable } from '@angular/core';
import { ApiEntity } from 'app/api/models/api-entity.model';
import { ApiDependenciesService } from 'app/api/services/api-dependencies.service';
import { ConfirmationDialogService } from 'app/shared/services/confirmation-dialog.service';
import { ListServiceBase } from 'app/shared/services/list-base.service';

import { OrderSearchListItemViewModel } from 'app/modules/order/order-search/order-search/models/order-search-list-item-view.model';
import { OrderSearchListItemModel } from 'app/modules/order/order-search/order-search/models/order-search-list-item.model';
import { UsersService } from 'app/modules/configuration/users/user-management/services/users.service';

@Injectable({ providedIn: 'root' })
export class OrderSearchListService extends ListServiceBase {

	public customerId: number;
	constructor(
		protected dependencies: ApiDependenciesService,
		protected confirmationDialogService: ConfirmationDialogService,
		private userService: UsersService,
	) {
		super(dependencies, confirmationDialogService);

		this.uiStateKey = 'order-search-list';

		this.initialiseFiltersSortAndPaging();
	}

	// populate initial filter properties
	private initialiseFiltersSortAndPaging() {
		// Add intialisation here
	}

	get baseEndpoint(): string {
		return '/orders';
	}
	baseEndpointWithId(id: number): string {
		return this.baseEndpoint + '/' + id;
	}
	protected getCommandStubEndpoint(itemId: number): string {
		return this.baseEndpointWithId(itemId);
	}

	// a number of endpoint getters are defined in ListServiceBase
	// not all endpoints will be required for all implementations

	// OVERRIDDEN from ListServiceBase
	protected getListEndpoint(): string {
		return this.baseEndpoint + '/list';
	}
	protected get exportListEndpoint(): string {
		if (this.customerId) {
			return this.getListEndpoint() + `/export?customerId=${this.customerId}`;
		}
		return this.getListEndpoint() + '/export';
	}

	// OVERRIDDEN from ListServiceBase
	// Create a new ViewModel specific to this list
	// Not necessary to set the viewmodel itemId as it is set in the viewModel constructor
	createListViewModel(dataModel: ApiEntity) {
		return new OrderSearchListItemViewModel(dataModel as OrderSearchListItemModel, this.userService);
	}

	// OVERRIDDEN from ListServiceBase
	// Map to data model from the API response item for each list row item
	// There is an assumption here that the response item directly maps to the angular model and so can just be assigned
	getMappedListItemDataModel(responseItem: any): ApiEntity {
		const model: OrderSearchListItemModel = responseItem;
		return model;
	}
	protected get filterLookupDataEndpoint(): string {
		return this.baseEndpoint + '/get-filter-lookup-data';
	}

	async getFilterLookupData(): Promise<any> {
		let model: any;
		await this.setEndpoint(this.filterLookupDataEndpoint)
			.getSingle()
			.then((response: any) => {
				model = response;
			});
		return Promise.resolve(model);
	}

	async sendOrderConfirmationEmail(data: any) {
		// const  endpoint = this.baseEndpointWithId(data) + `/send-order-confirmation/`;
		// await this.setEndpoint( endpoint).sendCommand();
		// await this.sendCommand(data, 'send-order-confirmation-email');
		this.startBlockUI();
		await this.setEndpoint(this.getCommandStubEndpoint(data) + '/send-order-confirmation-email')
			.command(data)
			.then((response) => {})
			.catch((error) => {})
			.finally(() => {
				this.stopBlockUI();
			});
		return Promise.resolve();
	}

}
